Template.band.onCreated(function(){
  var self = this;
  self.autorun(function(){
    var id =  Router.current().params.bandId;
    self.subscribe('singleBand', id);
  });
});

Template.band.helpers({
  band: () => {
    var id =  Router.current().params.bandId;
    return Bands.findOne({_id: id});
  }
});

AutoForm.addHooks(['updateBandForm'], {
    onSuccess: function (operation, result, template) {
      alert("Deine Band wurde erfolgreich aktualisiert")
    }
});
